(function () {

  'use strict';

  function pxConfirm() {
    return {
      restrict: 'EA',
      scope: {
        confirmData: '=confirmData',
        callback: '&callback'
      },
      templateUrl: 'app/directives/confirmDirective/confirm.template.html',
      link: function (scope) {

        scope.confirmContent = scope.confirmData;

        scope.confirm = function (boolean) {
          scope.callback({ boolean: boolean });
        };

      }
    };
  }

  pxConfirm.$inject = [];

  angular
    .module('printix-admin')
    .directive('pxConfirm', pxConfirm);

})();
